import _get from 'lodash-es/get';
import { connect } from 'react-redux';
import { getGroupDetailsInitiate } from '../../actions/groups';
import GroupDetails from './GroupDetails';
import { getEmployeesForGroupInitiate } from '../../actions/employee';
import { currentFlowTypeEnum } from '../common/components/constants';
import { getCompanyMappedOfficesInitiate } from '../../actions/company';

const mapStateToProps = state => {
  const groupData = _get(state, 'groups.groupData', {});
  const group = _get(groupData, 'group', {});
  const employeesData = _get(state, 'employees', {});
  const selectedWorkspace = _get(state, 'user.selectedWorkspace', {});
  const viewOnlyMode = _get(state, 'user.view_only_mode', false);
  const currentFlow = _get(
    state,
    'user.currentFlow',
    currentFlowTypeEnum.FLOW_TYPE_PPI,
  );
  return {
    currentFlow,
    viewOnlyMode,
    group,
    employeesData,
    groupData,
    selectedWorkspace,
    fetchingGroupDetails:
      _get(state, 'apiState.GET_GROUP_DETAILS.isFetching', true) &&
      !_get(state, 'apiState.GET_GROUP_DETAILS.isIdle', false),
    fetchedGroupDetails: _get(
      state,
      'apiState.GET_GROUP_DETAILS.success',
      true,
    ),
    fetchingEmployeesForGroup:
      _get(state, 'apiState.GET_EMPLOYEES_FOR_GROUP.isFetching', true) &&
      !_get(state, 'apiState.GET_EMPLOYEES_FOR_GROUP.isIdle', false),
    fetchedEmployeesForGroup: _get(
      state,
      'apiState.GET_EMPLOYEES_FOR_GROUP.success',
      true,
    ),
  };
};

const mapDispatchToProps = dispatch => ({
  getGroupDetails: payload => dispatch(getGroupDetailsInitiate(payload)),
  getEmployeesForGroup: payload =>
    dispatch(getEmployeesForGroupInitiate(payload)),
  getAllCompanyMappedOffices: payload =>
    dispatch(getCompanyMappedOfficesInitiate(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GroupDetails);
